import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e99160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexbox" }
const _hoisted_2 = { class: "videoMsg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["poster", "src"]
const _hoisted_5 = {
  key: 0,
  class: "list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("em"),
  /*#__PURE__*/_createElementVNode("em"),
  /*#__PURE__*/_createElementVNode("em")
], -1))
const _hoisted_8 = ["title", "textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]

import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import videos from "@/views/Video/Videos";

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoMore',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile as boolean);
const language = computed(() => store.state.appLanguage);
const videoLists = reactive(videos);
const activeInfo = ref(videoLists[0]);
const triggerClick = (i: number) => {
  videoLists.map((item, index) => {
    item.isPlay = false;
    if (i === index) {
      item.isPlay = true;
      activeInfo.value = item;
    }
  });
  if (activeInfo.value.platform === "video") {
    setTimeout(() => {
      const myVideoContent: HTMLVideoElement = document.getElementById(
        "myvideo"
      ) as HTMLVideoElement;
      myVideoContent && myVideoContent.play();
    }, 1000);
  }
};
const router = useRouter();
const more = (name?: string) => {
  router.push({
    name: name || "helpFAQ",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['realize', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.learn_more")), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (activeInfo.value.platform === 'bilibili')
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: activeInfo.value.src,
              scrolling: "no",
              border: "0",
              frameborder: "no",
              framespacing: "0",
              allowfullscreen: "true",
              class: "w-lightbox-embed"
            }, "\n        ", 8, _hoisted_3))
          : _createCommentVNode("", true),
        (activeInfo.value.platform === 'video')
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              id: "myvideo",
              poster: activeInfo.value.poster,
              src: activeInfo.value.src,
              controls: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoLists, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass({ active: item.isPlay }),
                  onClick: ($event: any) => (triggerClick(index))
                }, [
                  _hoisted_7,
                  _createElementVNode("span", {
                    class: "tit",
                    title: _unref(language) === 'zh' ? item.title : item.titleEn,
                    textContent: _toDisplayString(_unref(language) === 'zh' ? item.title : item.titleEn)
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", {
                    class: "duration",
                    textContent: _toDisplayString(item.duration)
                  }, null, 8, _hoisted_9)
                ], 10, _hoisted_6))
              }), 256))
            ]),
            _createElementVNode("div", {
              class: "more shadowBtn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (more('helpVideo'))),
              textContent: _toDisplayString(_ctx.$t('videoInfo.moreVideo'))
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "more shadowBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (more('helpVideo'))),
          textContent: _toDisplayString(_ctx.$t('videoInfo.moreVideo'))
        }, null, 8, _hoisted_11))
      : _createCommentVNode("", true)
  ], 2))
}
}

})